<template>
  <div class="bg position-relative">
    <div class="background-top"></div>
    <div id="feature"/>
    <div class="background-bottom"></div>


    <div class="bc">
      <img class="img_2" src="/img/image/home/main_img1.png" loading="lazy" alt/>


      <img class="img_1" src="/img/image/home/t_1.png" loading="lazy" alt="脆皮豬五花"/>


      <img class="img_4" ref="img4" src="/img/image/home/t_4.png" loading="lazy" alt="油脂在舌尖融化之感" />
      <img class="img_5" ref="img5" src="/img/image/home/t_2_3.png" loading="lazy" alt="外皮金黃酥脆 肉質軟嫩多汁"/>

      <button type="button" class="btn buy_btn btn_style" @click="clickBuy">
        <div class="row justify-content-center">
                  <span class="btn_font text-white">
                   立即品嚐
                  </span>
          <div style="width: 16px"/>
          <img src="/img/image/icon/arrow.png" loading="lazy" style="width: 40px; height: 40px" alt>
        </div>
      </button>

      <button type="button" class="btn join_btn btn_style" @click="clickJoin">
        <div class="row justify-content-center">
                  <span class="btn_font text-white">
                   我要加盟
                  </span>
          <div style="width: 16px"/>
          <img src="/img/image/icon/arrow.png" loading="lazy" style="width: 40px; height: 40px" alt>
        </div>
      </button>

      <div class="img_3_container" ref="img3">
        <img class="img_3" src="/img/image/home/main_img2.png" loading="lazy" alt/>

        <div class="line_top_container">
          <div class="line_top_text text-white text-nowrap">
            <div class="font-weight-900 line_top_text_1">嚴選CAS認證</div>
            <div class="font-weight-500 line_top_text_2">台灣精品無帶骨豬五花</div>
          </div>
          <div style="width: 20px"/>
          <img class="line_top" loading="lazy" alt/>
        </div>


        <div class="line_bottom_container">
          <img class="line_bottom" loading="lazy" alt/>
          <div style="width: 20px"/>
          <div class="line_bottom_text text-white text-left text-nowrap">
            <div class="font-weight-500">嚴選30種以上</div>
            <div class="font-weight-500">天然辛香料調味</div>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Stage_1",
  data() {
    return {};
  },
  mounted() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.img4.classList.add('fadeInImg1');
          this.$refs.img5.classList.add('fadeInImg1');
          this.$refs.img3.classList.add('fadeIn');
        }
      });
    }, {threshold: 0.5}); // 阈值为 0.1，即元素至少有 10% 可见时触发
    observer.observe(this.$refs.img4);
    observer.observe(this.$refs.img5);
    observer.observe(this.$refs.img3);
  },
  methods: {
    clickBuy() {
      const tasteNow = document.getElementById('taste_now');
      tasteNow.scrollIntoView({behavior: 'smooth'});
    },
    clickJoin() {
      this.$router.push({path: '/join'});
    },
  },
}
</script>

<style lang="scss" scoped>

.bg {
  max-height: 2160px;
}

.bc {
  max-width: 1440px;
}

.background-top, .background-bottom {
  background-size: cover;
  background-position: center;
  width: 100%;
}

/* 背景圖片設置 */
.background-top {
  background-image: url('/img/image/background/bg_s1.png');
  height: 890px;
}

.background-bottom {
  background-image: url('/img/image/background/bg_s2.png');
  height: 1270px;
}

@media (max-width: 1440px) {
  .background-top {
    height: 890px;
  }
  .background-bottom {
    height: 1270px;
  }
}

@media (max-width: 900px) {

  .background-bottom {
    height: 1200px;
  }
}

@media (max-width: 900px) {

  .background-bottom {
    height: 1100px;
  }
}

@media (max-width: 768px) {
  .background-bottom {
    height: 1000px;
  }
}

@media (max-width: 576px) {
  .background-top {
    height: 622px;
  }
  .background-bottom {
    height: 747px;
  }
}

@media (max-width: 500px) {
  .background-bottom {
    height: 700px;
  }
}

@media (max-width: 375px) {
  .background-bottom {
    height: 688px;
  }
}


@media (max-width: 360px) {
  .background-top {
    height: 400px; /* 自定義高度 */
  }
  .background-bottom {
    height: 675px; /* 自定義高度 */
  }
}


//主標題
.img_1 {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 878px;
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 1440px) {
  .img_1 {
    max-width: 878px;
  }
}

@media (max-width: 992px) {
  .img_1 {
    max-width: 720px;
    width: 72vw;
  }
}

@media (max-width: 576px) {
  .img_1 {
    top: 40px;
    max-width: 500px;
    width: 86vw
  }
}

@media (max-width: 360px) {
  .img_1 {
    top: 30px;
    max-width: 283px;
    width: 78vw
  }
}


//肉盤圖
.img_2 {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 1296px;
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 1440px) {
  .img_2 {
    max-width: 1296px;
  }
}

@media (max-width: 992px) {
  .img_2 {
    top: 390px;
    width: 976px;
  }
}

@media (max-width: 576px) {
  .img_2 {
    top: 190px;
    transform: translate(0, 0);
    left: -210px;
    max-width: 788px;
  }
}

@media (max-width: 360px) {
  .img_2 {
    top: 110px;
    left: -170px;
    max-width: 514px;
  }
}


//左邊文字 油脂在舌尖融化之感
.img_4 {
  position: absolute;
  top: 1040px;
  left: 150px;
  max-width: 52px;
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  opacity: 0;
}

@media (max-width: 1440px) {
  .img_4 {
    max-width: 52px;
    left: 150px;
  }
}

@media (max-width: 1300px) {
  .img_4 {
    left: 120px;
  }
}

@media (max-width: 1200px) {
  .img_4 {
    left: 100px;
  }
}

@media (max-width: 1100px) {
  .img_4 {
    left: 60px;
  }
}

@media (max-width: 1000px) {
  .img_4 {
    max-width: 40px;
    left: 30px;
  }
}

@media (max-width: 900px) {
  .img_4 {
    top: 920px;
  }
}

@media (max-width: 576px) {
  .img_4 {
    max-width: 31px;
    top: 780px;
    left: 35px;
  }
}


@media (max-width: 450px) {
  .img_4 {
    max-width: 31px;
    top: 750px;
    left: 20px;
  }
}

@media (max-width: 400px) {
  .img_4 {
    max-width: 25px;
    //top: 750px;
    //left: 20px;
  }
}


@media (max-width: 360px) {
  .img_4 {
    left: 15px;
    top: 500px;
    max-width: 23px;
  }
}

//右邊文字 外皮金黃酥脆 肉質軟嫩多汁
.img_5 {
  position: absolute;
  top: 780px;
  //left: 1015px;
  right: 182px;
  max-width: 248px;
  width: 100%;
  height: auto;
  z-index: 10;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  opacity: 0;
}

@media (max-width: 1440px) {
  .img_5 {
    max-width: 248px;
    right: 12vw;
  }
}

@media (max-width: 992px) {
  .img_5 {
    max-width: 242px;
    right: 120px;
    width: 20vw;
  }
}


@media (max-width: 576px) {
  .img_5 {
    max-width: 148px;
    top: 660px;
    right: 50px;
  }
}

@media (max-width: 360px) {
  .img_5 {
    top: 420px;
    right: 50px;
    max-width: 102px;
  }
}


.btn_style {
  padding: 15px 30px;
  background-color: #D56835;
  border-radius: 10px;
  border: 4px solid white;
  box-shadow: 0 5px 10px 0 #00000054;
}

.btn_font {
  font-family: Noto Sans TC;
  font-size: 40px;
  font-weight: 900;
  line-height: 34.75px;
  letter-spacing: 0.1em;
  text-align: center;
}

.buy_btn {
  position: absolute;
  top: 340px;
  left: 66%;
}


@media (max-width: 992px) {
  .buy_btn {
    top: 310px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 576px) {
  .buy_btn {
    visibility: hidden;
  }
}

.join_btn {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 10;
}

.join_btn:hover {
  left: 50% !important;
  transform: translate(-50%, 0) !important;
}

@media (max-width: 1440px) {
  .join_btn {
    bottom: 60px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 1100px) {
  .join_btn {
    bottom: 30px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}


@media (max-width: 992px) {
  .join_btn {
    bottom: 100px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 900px) {
  .join_btn {
    bottom: 30px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 680px) {
  .join_btn {
    visibility: hidden;
  }
}

.img_3_container {
  position: absolute; /* 絕對定位 */
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%; /* 可根據需求調整 */
  max-width: 1440px; /* 根據需求設置最大寬度 */
  opacity: 0;
}

@media (max-width: 1440px) {
  .img_3_container {
    max-width: 1440px;
  }
}

@media (max-width: 992px) {
  .img_3_container {
    width: 140%;
  }
}

@media (max-width: 576px) {
  .img_3_container {
    max-width: 576px;
    width: 100%;
  }
}

@media (max-width: 360px) {
  .img_3_container {
    max-width: 550px;
    width: 150%;
  }
}

//肉圖
.img_3 {
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

.line_top_container {
  position: absolute;
  top: 20%; /* 根據需求調整相對位置 */
  left: 36%;
  transform: translate(-50%, -50%); /* 根據需求調整位置 */
  max-width: 450px;
  width: 100%;
  //row
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

@media (max-width: 1440px) {
  .line_top_container {
    top: 20%;
    left: 36%;
  }
}

@media (max-width: 992px) {
  .line_top_container {
    top: 20%;
    left: 40%;
  }
}

@media (max-width: 900px) {
  .line_top_container {
    top: 30%;
    left: 40%;
  }
}


@media (max-width: 768px) {
  .line_top_container {
    top: 30%;
    left: 45%;
  }
}


@media (max-width: 576px) {
  .line_top_container {
    top: 10%;
    left: 38%;
    flex-direction: column;
    width: auto;
    align-items: flex-end
  }
}

@media (max-width: 360px) {
  .line_top_container {
    top: 10%;
    left: 44%;
  }
}


.line_top {
  margin-top: 10px;
  max-width: 190px;
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  content: url('/img/image/home/line_1.png');
}

@media (max-width: 1440px) {
  .line_top {
    max-width: 190px;
  }
}

@media (max-width: 992px) {
  .line_top {
    max-width: 190px;
  }
}


@media (max-width: 768px) {
  .line_top {
    max-width: 100px;
  }
}

@media (max-width: 576px) {
  .line_top {
    content: url('/img/image/home/line_3.png');
    max-width: 50px;
  }
}

@media (max-width: 425px) {
  .line_top {
    max-width: 40px;
  }
}

@media (max-width: 360px) {
  .line_top {
    max-width: 30px;
  }
}


.line_top_text {
  text-align: right;
}

@media (max-width: 360px) {
  .line_top_text {
    text-align: left;
  }
}


.line_top_text_1 {
  font-size: 30px;
}


@media (max-width: 768px) {
  .line_top_text_1 {
    font-size: 24px;
  }
}

@media (max-width: 576px) {
  .line_top_text_1 {
    font-size: 24px;
  }
}

@media (max-width: 425px) {
  .line_top_text_1 {
    font-size: 18px;
  }
}


@media (max-width: 360px) {
  .line_top_text_1 {
    font-size: 12px;
  }
}

.line_top_text_2 {
  font-size: 24px;
}

@media (max-width: 576px) {
  .line_top_text_2 {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .line_top_text_2 {
    font-size: 16px;
  }
}

@media (max-width: 360px) {
  .line_top_text_2 {
    font-size: 12px;
  }
}


.line_bottom_container {
  position: absolute;
  top: 70%; /* 根據需求調整相對位置 */
  left: 50%;
  transform: translate(-50%, -50%); /* 根據需求調整位置 */
  max-width: 420px;
  //height: 200px;
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  align-items: baseline;
}

@media (max-width: 1440px) {
  .line_bottom_container {
    top: 70%;
    left: 50%;
  }
}

@media (max-width: 992px) {
  .line_bottom_container {
    top: 70%;
    left: 50%;
  }
}

@media (max-width: 576px) {
  .line_bottom_container {
    top: 75%;
    left: 55%;
    flex-direction: column;
    width: auto;
  }
}

@media (max-width: 360px) {
  .line_bottom_container {
    top: 75%;
    left: 55%;
  }
}


.line_bottom {
  max-width: 228px;
  width: 100%;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  content: url('/img/image/home/line_2.png');
}

@media (max-width: 576px) {
  .line_bottom {
    content: url('/img/image/home/line_4.png');
    max-width: 32px;

  }
}

@media (max-width: 360px) {
  .line_bottom {
    max-width: 32px;
  }
}


.line_bottom_text {
  font-size: 24px;
}

@media (max-width: 576px) {
  .line_bottom_text {
    padding-top: 5px;
    padding-left: 20px;
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .line_bottom_text {
    font-size: 12px;
  }
}


.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

@keyframes fadeIn {
  from {
    margin-bottom: -500px;
    opacity: 0.5;
  }
  to {
    margin-bottom: 0;
    opacity: 1;
  }
}


.fadeInImg1 {
  animation-name: fadeInImg1;
  animation-duration: 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeInImg1 {
  from {
    margin-top: 200px;
    opacity: 0.5;
  }
  to {
    margin-top: 000px;
    opacity: 1;
  }
}


</style>
